import React from 'react';
import PropTypes from 'prop-types';

import Navigation from 'components/Navigation';

import navItems from './items.json';

class CohortNavigation extends React.PureComponent {
  static getDerivedStateFromProps(props) {
    return {
      items: CohortNavigation.normalizeItems(navItems, props),
    };
  }

  static normalizeItems(items, props) {
    const { cohortId } = props;

    return navItems.map((navItem) => {
      const item = { ...navItem };

      if (item.to) {
        item.to = item.to.replace(/:cohortId/, cohortId);
      } else {
        item.disabled = true;
      }

      return item;
    });
  }

  state = {};

  render() {
    const { selectedKey } = this.props;
    const { items } = this.state;

    return (
      <Navigation
        title={'class'}
        items={items}
        backTo={'/classes'}
        selectedKey={selectedKey}
        showHeader
      />
    );
  }
}

CohortNavigation.propTypes = {
  selectedKey: PropTypes.string,
};

export default CohortNavigation;
